import { Component, OnInit, Input } from '@angular/core';
import { Person } from '../../../models/person';
import { Usef_person } from '../../../models/usef/usef_person';

@Component({
  standalone: false,
  selector: 'view-person',
  templateUrl: './view-person.component.html',
styleUrls:  ['./view-person.component.css']
})

export class ViewPersonComponent implements OnInit {

	@Input() person: Person = new Person({});
	@Input() usef_person: Usef_person = new Usef_person({phone_numbers:[]});

  constructor() {}

  ngOnInit() {
  }

}
